import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		TransitionRoot
	} from '@headlessui/vue'

	// eslint-disable-next-line
	
	const __default__ = { name: 'VSubheading' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		level: {
			type: Number,
			default: 2
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: true,
    as: `h${__props.level}`,
    class: "text-base/7 font-semibold text-zinc-950 sm:text-sm/6 dark:text-white"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as"]))
}
}

})